import { WedgeProduct } from '@ekhodealer/ekho-common';

import type { Product } from '../types';

import { ONBOARDING_FIELD } from './onboardingFields';

export const PRODUCT_CATALOG: readonly Product[] = [
	{
		id: WedgeProduct.AI_BDC,
		name: 'AI BDC',
		description: 'Automated inbound lead engagement via SMS and web chat, 24/7.',
		features: [
			'Engages inbound leads automatically via SMS',
			'Answers inventory questions using live inventory data',
			'Books appointments directly into your workflow',
			'Works across web chat and SMS channels',
		],
		priceMonthly: 29900,
		priceDisplay: '$299/mo',
		icon: 'message-circle',
		requiredFields: [
			ONBOARDING_FIELD.DEALER_NAME,
			ONBOARDING_FIELD.EMAIL,
			ONBOARDING_FIELD.WEBSITE_URL,
		],
	},
	{
		id: WedgeProduct.AI_WEBSITE,
		name: 'AI Native Dealer Website',
		description: 'A fully AI-powered dealer website that converts visitors into buyers.',
		features: [
			'AI-generated pages optimized for conversions',
			'Integrated inventory browsing and search',
			'Built-in lead capture and chat',
			'SEO-optimized and mobile-first',
		],
		priceMonthly: 49900,
		priceDisplay: '$499/mo',
		icon: 'globe',
		requiredFields: [
			ONBOARDING_FIELD.DEALER_NAME,
			ONBOARDING_FIELD.EMAIL,
			ONBOARDING_FIELD.WEBSITE_URL,
			ONBOARDING_FIELD.PHONE,
			ONBOARDING_FIELD.INVENTORY_URLS,
		],
		disabled: true,
		comingSoon: true,
	},
	{
		id: WedgeProduct.VOICE_SERVICE,
		name: 'Voice AI for Service Scheduling',
		description: 'AI voice agent that handles inbound service appointment calls.',
		features: [
			'Answers service calls automatically',
			'Schedules appointments in real time',
			'Handles rescheduling and cancellations',
			'Integrates with your DMS calendar',
		],
		priceMonthly: 19900,
		priceDisplay: '$199/mo',
		icon: 'phone',
		requiredFields: [
			ONBOARDING_FIELD.DEALER_NAME,
			ONBOARDING_FIELD.EMAIL,
			ONBOARDING_FIELD.PHONE,
			ONBOARDING_FIELD.BUSINESS_HOURS,
		],
		disabled: true,
		comingSoon: true,
	},
	{
		id: WedgeProduct.CREDIT_APP_FILL,
		name: 'Credit Application Form Fill',
		description: 'AI-powered auto-fill for credit applications from customer data.',
		features: [
			'Pre-fills credit apps from existing customer data',
			'Supports major lender formats',
			'Reduces errors and submission time',
			'Secure PII handling and encryption',
		],
		priceMonthly: 17900,
		priceDisplay: '$179/mo',
		icon: 'file-text',
		requiredFields: [ONBOARDING_FIELD.DEALER_NAME, ONBOARDING_FIELD.EMAIL],
		disabled: true,
		comingSoon: true,
	},
	{
		id: WedgeProduct.AI_CRM,
		name: 'AI Native CRM',
		description: 'An AI-native CRM built for modern dealerships.',
		features: [
			'AI-driven lead scoring and prioritization',
			'Automated follow-up sequences across channels',
			'Unified customer timeline with full interaction history',
			'Seamless integration with your existing DMS',
		],
		priceMonthly: 0,
		priceDisplay: '',
		icon: 'users',
		requiredFields: [ONBOARDING_FIELD.DEALER_NAME, ONBOARDING_FIELD.EMAIL],
		disabled: true,
		comingSoon: true,
	},
] as const;

export const PRODUCT_BY_ID = new Map(PRODUCT_CATALOG.map((product) => [product.id, product]));
